// client/legend-cms/src/predictionTeams/PredictionTeamCreate.js
import React from 'react';
import {
  Create,
  SimpleForm,
  TextInput,
  SelectInput,
  BooleanInput,
  ImageInput,
  ImageField,
  required,
} from 'react-admin';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';

const useStyles = makeStyles({
  inline: {
    display: 'inline-block',
    marginLeft: '1em',
    '&.first-child': {
      marginLeft: 0,
    },
  },
});

const typeChoices = [
  { id: 'national_team', name: 'Seleção nacional' },
  { id: 'club', name: 'Clube' },
];

const PredictionTeamCreate = (props) => {
  const classes = useStyles();

  return (
    <Create title="Cadastrar time" {...props}>
      <SimpleForm>
        <TextInput
          source="name"
          label="Nome"
          helperText="Nome de exibição. Ex: Brasil, Flamengo."
          validate={required()}
          formClassName={clsx(classes.inline, 'first-child')}
        />

        <TextInput
          source="slug"
          label="Slug (identificador único)"
          helperText="Ex: brazil, flamengo. Não pode repetir."
          validate={required()}
          formClassName={classes.inline}
        />

        <div />

        <SelectInput
          source="type"
          label="Tipo"
          choices={typeChoices}
          validate={required()}
          formClassName={clsx(classes.inline, 'first-child')}
        />

        <BooleanInput
          source="active"
          label="Ativo"
          defaultValue={true}
          formClassName={classes.inline}
        />

        <div />

        <ImageInput
          source="image"
          label="Bandeira/Brasão"
          accept="image/jpeg,image/jpg,image/png,image/webp"
          helperText="jpg, png ou webp. Opcional — se vazio, o app usa o fallback local."
        >
          <ImageField source="src" title="title" />
        </ImageInput>
      </SimpleForm>
    </Create>
  );
};

export default PredictionTeamCreate;
